export default __webpack_public_path__ + "static/media/layout_dark_pattern-feeling.317120ab.svg";